$(() => {
    const galleries = document.querySelectorAll('.wp-block-gallery')

    if (galleries) {
        galleries.forEach((gallery) => {
            gallery.classList.add('flexbin')
            gallery.classList.add('flexbin-margin')

            let figures = gallery.querySelectorAll('.wp-block-image')

            figures.forEach((figure) => {
                let a = document.createElement('a')
                let img = figure.querySelector('img')
                let url = img.getAttribute('src')

                a.setAttribute('data-pswp-src', url)
                a.setAttribute('href', url)
                a.setAttribute('data-pswp-width', img.naturalWidth)
                a.setAttribute('data-pswp-height', img.naturalHeight)

                figure.appendChild(a)
            })

            const lightbox = new PhotoSwipeLightbox({
                gallery: '.wp-block-gallery',
                children: 'figure',
                pswpModule: () => import('photoswipe')
            })

            lightbox.on('uiRegister', function () {
                lightbox.pswp.ui.registerElement({
                    name: 'custom-caption',
                    order: 9,
                    isButton: false,
                    appendTo: 'root',
                    html: 'Caption text',
                    onInit: (el, pswp) => {
                        lightbox.pswp.on('change', () => {
                            const currSlideElement = lightbox.pswp.currSlide.data.element

                            if (currSlideElement) {
                                const hiddenCaption = currSlideElement.querySelector('figcaption')

                                if (hiddenCaption) el.innerHTML = hiddenCaption.textContent

                                el.style.display = !hiddenCaption ? 'none' : 'block'
                            }
                        })
                    }
                })
            })

            lightbox.init()
        })
    }
})
